<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div v-if="idAnexoGrupo==3">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Coleta</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objReferencia.id) }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Protocolo</label>
                    <div class="field-label field-label-center">{{ objReferencia.xsequencia }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label">{{ objReferencia.nmestabelecimento }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Tipo Amostra</label>
                    <div class="field-label">{{ objReferencia.xamostra_categoria }}</div>
                </div>

                <div class="form-item-char40">
                    <label class="label-caption">Nome Oficial</label>
                    <div class="field-label">{{ objReferencia.amostra_nmoficial }}</div>
                </div>
            </div>


            
            <div class="row row-space">
                <div class="form-item-data">
                    <label class="label-caption" >Data</label>
                    <input type="date" v-model="edData" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Laboratório</label>
                    <input type="text" v-model="edNmLaboratorio" maxlength="100" v-uppercase />
                </div>

                <div class="form-item">
                    <label class="label-caption">Identificação</label>
                    <input type="text" v-model="edIdentificacao" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-char30">
                    <ConformeNaoConformeSelect v-model:resultadoSelecionado="resultadoSelecionado" />
                </div>
            </div>
        </div>


        <div v-else class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome/Identificação</label>
                <input type="text" v-model="docAnexo.nmdoc" maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption" >Valido Até</label>
                <input type="date" v-model="docAnexo.dtvalidade" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Observações</label>
                <textarea v-model="docAnexo.obspostagem" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Selecionar Arquivo (PDF ou JPG):</label>
                <input type="file" @change="onFileChange" accept=".pdf,.jpg" />
            </div>
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarAnexo">Enviar</button>
            <button type="button" class="btn-cancel" @click="closeForm">Cancelar</button>
        </div>
    </div>

    <div v-if="resultadoSelecionado==='NC'">
        <div class="analise-table">
            <div v-for="(item, idx) in lsAnalises" :key="idx" :class="['analise-row', { 'is-selected': item.selected }]">
                <div class="analise-info">
                    <span class="tipo">{{ item.tpanalise }}</span>
                    <span class="nome">{{ item.nmanalise }}</span>
                </div>

                <input
                    v-if="item.selected"
                    v-model="item.detalhe"
                    type="text"
                    class="input-detalhe"
                    placeholder="Descreva a inconformidade"
                    maxlength="200"
                    v-uppercase/>

                <button class="btn-toggle" @click="toggle(item)">
                    {{ item.selected ? '❌ Desmarcar' : '⚠️ Não conforme' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAnexoUpload } from '@/models/anexoUpload';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import ConformeNaoConformeSelect from '@/selects/estaticos/ConformeNaoConformeSelect.vue';
import MensagemAlerta from '../utils/MensagemAlerta.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idAnexoGrupo: {type: Number, default: 0},
    idDrivePasta: {type: Number, default: 0},
    idTpDoc: {type: Number, default: 0},
    objReferencia: {type: Object}
});

const arquivoSelecionado = ref(null);

const edData = ref(null);
const edNmLaboratorio = ref(null);
const edIdentificacao = ref(null);
const lsAnalises = ref([]);
const resultadoSelecionado = ref(null);

const docAnexo = criarAnexoUpload();
const isLoading = ref(false);
const msgAlerta = ref(null);

const closeForm = () => {emit('close');}


async function lerDados(){
    try{
        if ((props.idAnexoGrupo==3) && (props.objReferencia != null)){
            // LER DADOS DAS ANÁLISES REQUERIDAS
            msgAlerta.value=null;
            const req = await Api.genericPost('/lspla/pla01/analises', {idep: globalStore.idep, idreferencia: props.objReferencia.id});
            lsAnalises.value = req.map(item => ({
                ...item,          // tpanalise, nmanalise
                selected: false,  // flag de não-conforme
                detalhe: ''       // texto da inconformidade
            }));
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;}
}


function onFileChange(e) {
    const target = e.target;
    const files = target.files;
    if (files && files.length > 0) {
        arquivoSelecionado.value = files[0]
    } else {
        arquivoSelecionado.value = null
    }
}


const salvarAnexo = async() => {
    try{
        let marcados = [];
        msgAlerta.value=null;
        if (props.idAnexoGrupo===3){
            if (!edData.value)  throw new Error('Informe data do resultado');
            if (!edNmLaboratorio.value)  throw new Error('Informe nome do laboratório');
            if (!edIdentificacao.value)  throw new Error('Informe identificação');
            if (!resultadoSelecionado.value)  throw new Error('Informe análise de resultado');
            if (resultadoSelecionado.value=='NC'){
                marcados = lsAnalises.value.filter(a => a.selected);
                if (marcados.length === 0) throw new Error('Selecione ao menos uma análise não conforme.');

                const semDetalhe = marcados.filter(a => !a.detalhe.trim());
                if (semDetalhe.length > 0) throw new Error('Preencha o detalhe para todas as análises marcadas.');
            }
        }else{
            if (!docAnexo.nmdoc) throw new Error('Informe nome do documento');
            if (!docAnexo.dtvalidade) throw new Error('Informe validade do documento');
        }
        if (!arquivoSelecionado.value) throw new Error('Necessário anexar algum documento');
        isLoading.value=true;

        const file = arquivoSelecionado.value;
        docAnexo.tipo = file.type === 'application/pdf' ? '0' : '1';
        docAnexo.fname = file.name;

        docAnexo.idanexogrupo = props.idAnexoGrupo;
        docAnexo.idep = globalStore.idep;
        docAnexo.idtpdoc = props.idTpDoc;
        docAnexo.idestabelecimento = globalStore.idestabelecimento;
        docAnexo.idupostagem = globalStore.idusuario;
        docAnexo.idlogin = globalStore.idlogin;
        const r = await Api.genericPost('/operacoes/solicitar/upload', docAnexo);

        if (r.bolok==1){
            // INICIO MÉTODO DE ENVIO DO DOCUMENTO PARA S3 CONFORME EXEMPLO CHATGPT

            const idAnexo = r.id;
            const uploadUrl = r.upload_url;
            const method = r.upload_method || 'PUT';


            const resp = await fetch(uploadUrl, {
                method,
                body: file,
                headers: {
                    'Content-Type': file.type || 'application/octet-stream'
                }
            });


            if (!resp.ok) {
                const txt = await resp.text();
                console.error('Erro no PUT S3', resp.status, txt);
                throw new Error('Falha ao enviar o arquivo para o armazenamento.');
            }


            const eTag = resp.headers.get('etag') || '';


            // FIM MÉTODO DE ENVIO DO ANEXO PARA O S3
            const rConf = await Api.genericPut('/cad/anexo', {
                id: idAnexo,
                fsize: file.size,
                fhash: eTag.replace(/"/g, ''),
                storage_status: 1});

            if (rConf.bolok !== 1) throw new Error(rConf.erro);


            let confirmar;
            if (props.idAnexoGrupo==3){
                // ANEXO REFERENTE A RESULTADO DE COLETA... NECESSÁRIO GRAVAR REFERÊNCIA
                const ref = await Api.genericPut('/cad/pla01_resultado', {
                    idpla01: props.objReferencia.id,
                    idanexo: r.id,
                    dtresultado: edData.value,
                    nmlaboratorio: edNmLaboratorio.value,
                    tpresultado: resultadoSelecionado.value,
                    identificacao: edIdentificacao.value,
                    idlogin: globalStore.idlogin,
                    idusuario: globalStore.idusuario});
                confirmar = (ref.bolok==1);

                // ENVIO DAS ANÁLISES NÃO CONFORME

                for (const item of marcados){
                    const rnc = await Api.genericPut('/cad/pla01nc', {
                        id: 0,
                        idpla01: props.objReferencia.id,
                        nmanalise: item.nmanalise,
                        tpanalise: item.tpanalise,
                        informacoes: item.detalhe,
                        idlogin: globalStore.idlogin,
                        idusuario: globalStore.idusuario});

                    if (rnc.bolok !== 1) {
                        throw new Error(rnc.erro || 'Falha ao gravar análise não conforme');
                    }
                }

                if (ref.bolOk==0) msgAlerta.value = ref.erro;
            } else if (props.idAnexoGrupo==7) {
                // GRAVAR RELACIONAMENTO ARQUIVO x PASTA DE DRIVE
                const drive = await Api.genericPut('cad/drive/arquivo', {
                    id: 0,
                    idep: globalStore.idep,
                    iddrivepasta: props.idDrivePasta,
                    idanexo: r.id,
                    ativo: "S",
                    idlogin: globalStore.idlogin,
                    idusuario: globalStore.idusuario});
                confirmar = (drive.bolok==1);
            } else {confirmar = true}

            if (confirmar){
                emit('close');
                emit('save');
            }
        } else {msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

function toggle(item) {
    item.selected = !item.selected;
    if (!item.selected) {
        item.detalhe = '';
    }
}

onMounted(lerDados)

</script>


<style scoped>
.analise-table {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.analise-row {
    display: flex;
    align-items: center;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: background-color .2s;
}

.analise-row.is-selected {
    background-color: #ffecec;
}

.analise-info {
    flex: 1;
    display: flex;
    gap: 16px;
}

.tipo {
    font-weight: bold;
    width: 30px;
}

.nome {
    flex: 1;
    text-align: start;
}

.btn-toggle {
    margin-right: 12px;
    cursor: pointer;
    border: none;
    background: none;
    color: #007bff;
}

.btn-toggle:hover {
    text-decoration: underline;
}

.input-detalhe {
    flex: 2;
    padding: 4px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}
</style>
